<form class="detail-image-form" [formGroup]="detailImageForm">
    <label class="input-floating mb-24 input-room-number">
        <textarea #roomNumber formControlName="roomNumber" class="form-input" [placeholder]="'CHECK.ROOM_NUMBER' | translate"
            (keyup)="autoGrowTextZone($event)" (blur)="onFocusOutInputEvent('roomNumber', roomNumber.value )"
            (click)="clickTextarea()"></textarea>
        <span>{{ 'CHECK.ROOM_NUMBER' | translate }}</span>
    </label>

    <label class="input-floating mb-24">
        <textarea #comment formControlName="comment" class="form-input" [placeholder]="'CHECK.COMMENT' | translate"
            (keyup)="autoGrowTextZone($event)" (blur)="onFocusOutInputEvent('comment', comment.value )"
            (click)="clickTextarea()"></textarea>
        <span>{{ 'CHECK.COMMENT' | translate }}</span>
    </label>

    <button #hiddenOffcanvas style="display: none;" data-bs-toggle="offcanvas" data-bs-target="#quickCommentsOffcanvasRight" aria-controls="offcanvasRight"></button>
    <button type="button" class="quick-comments-button mb-4" (click)="openQuickCommentCanvas()"  [disabled]="!editable" >
        <img src="assets/icons/addDocumentOutlined.svg" />
        <span class="quick-comments-text">{{ 'CHECK.SELECTED_QUICK_COMMENTS' | translate }}</span>
        <span *ngIf="auditQuickCommentsSelected && auditQuickCommentsSelected.length > 0" class="badge">{{ auditQuickCommentsSelected.length }}</span>
    </button>

    <div *ngIf="auditQuickCommentsSelected && auditQuickCommentsSelected.length > 0" class="chips-container mb-24">
        <span *ngFor="let quickComment of auditQuickCommentsSelected" class="chip">{{ quickComment.quickComment.title }}</span>
    </div>

    <div class="datetime-info">
        <span class="label-info">{{ 'CHECK.DATE' | translate }}</span>
        <span class="label-info">{{ 'CHECK.TIME' | translate }}</span>
        <span *ngIf="stationAudit" class="data-info"> {{ stationAudit.creationDate | date: 'd-MMM-yy ' }} </span>
        <span *ngIf="stationAudit" class="data-info"> {{ stationAudit.creationDate | date: 'H:mm:ss' }} </span>
    </div> 
</form>
